import { Box, Button, Divider, MenuItem, Radio, Stack, } from "@vividtheory/minerva-lab";
import { capitalize } from "@vividtheory/minerva-legacy";
import React from "react";
import { useState } from "react";
import { LogicOperator } from "../type";
export const LogicOperatorPanelContainer = ({ colLogicOperator, handleLogicOperatorChange, onClose, }) => {
    const [localLogic, setLocalLogic] = useState(colLogicOperator);
    return (React.createElement(Stack, { width: 52.5 },
        React.createElement(Stack, { gap: 1, width: "100%", sx: { padding: 2 } }, Object.keys(LogicOperator).map((key) => {
            const typeKey = key;
            return (React.createElement(MenuItem, { startNode: React.createElement(Radio, { checked: localLogic === typeKey }), key: key, label: capitalize(key), selected: localLogic === typeKey, density: "dense", onClick: () => {
                    setLocalLogic(typeKey);
                }, sx: { height: 10 } }));
        })),
        React.createElement(Divider, null),
        React.createElement(Box, { sx: { padding: 2 } },
            React.createElement(Button, { fullWidth: true, disabled: localLogic === colLogicOperator, onClick: () => {
                    handleLogicOperatorChange(localLogic);
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                } }, "Apply"))));
};
//# sourceMappingURL=LogicOperatorPanelContainer.js.map